import { getAuditById } from "store/actions/audit-action"
import { AppDispatch, RootState } from "store/store"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setAuditDetail } from "store/slices/audits-slice"

export default (params: any) => {
    const dispatch: AppDispatch = useDispatch()

    const audit_detail = useSelector((state: RootState) => state.audit?.audit_detail);

    const [openIndex, setOpenIndex] = useState(null);

    const statusStyles = {
        'Completed': 'bg-primary',
        'Pending': 'bg-destructive',
        'In Progress': 'bg-primary/20',
    };

    useEffect(() => { 
        dispatch(setAuditDetail(null))
        dispatch(getAuditById({ auditId: params?.id }))
     }, [])

    return {
        audit_detail,
        setOpenIndex,
        openIndex,
        statusStyles
    }
}